module.exports = __webpack_public_path__ + "img/f37.4d8f840e.jpg";